import { ComponentType, useEffect, useState } from 'react';

export const SCROLL_GROW_THRESHOLD = 142;
export const SCROLL_SHRINK_THRESHOLD = 32;

export interface WithScrollThresholdProps {
  pastThreshold: boolean;
}

export function withScrollThreshold<T extends WithScrollThresholdProps>(WrappedComponent: ComponentType<T>) {
  return function ScrollAwareComponent(props: Omit<T, keyof WithScrollThresholdProps>) {
    const [pastThreshold, setPastThreshold] = useState(false);

    useEffect(() => {
      const scrollContainer = document.querySelector('main');
      if (!scrollContainer) return;

      const handleScroll = () => {
        if (pastThreshold && scrollContainer.scrollTop < SCROLL_SHRINK_THRESHOLD) {
          setPastThreshold(false);
        }
        if (!pastThreshold && scrollContainer.scrollTop > SCROLL_GROW_THRESHOLD) {
          setPastThreshold(true);
        }
      };

      scrollContainer.addEventListener('scroll', handleScroll);

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    }, [pastThreshold]);

    return <WrappedComponent {...(props as T)} pastThreshold={pastThreshold} />;
  };
}
